import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IVideo } from '../models/responseModels'

export class GetVideoListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/video/list',
      requesterInfo,
    })
  }

  public async getVideos(): Promise<IVideo[]> {
    return await this.getAsync<IVideo[]>()
  }
}
